let TOOLS = TOOLS || {};

/**
 * 追従式無料査定依頼ボタンは固定の無料査定ボタンが見切れると同時に出現
 */
TOOLS.SCROLL_DISPLAY = {
  $freeAssessment: null,
  $form: null,
  position: null,

  /**
   * 初期処理
   */
  init: function() {
    var self = this;
    console.log('SCROLL_DISPLAY');

    self.$freeAssessment = $('.js-fixed-bottom');
    self.$form = $('.js-sell-top-form');

    self.setPosition();

    $(window).on('changeDisplayMode', function() {
      self.setPosition();
    })

    // スクロール時
    $(window).on('scroll', function() {
      self.onScrolling();
    });
  },

  /**
   * スクロール時の処理
   */
  onScrolling: function() {
    var self = this;
    var currentPos = $(window).scrollTop(); // 現在位置

    if (currentPos < self.position) {
      self.$freeAssessment.removeClass('--is-active');
    } else {
      self.$freeAssessment.addClass('--is-active');
    }
  },

  /**
   * 固定の無料査定ボタンを設定・再設定
   */
  setPosition: function() {
    var self = this;
    self.position = self.$form.offset().top + self.$form.height();
  },
};

$(function() {
  TOOLS.SCROLL_DISPLAY.init();
});
